module.exports = __webpack_public_path__ + "static/img/business2.fb5c683.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/img/business2.png
// module id = Wwo3
// module chunks = 1